module.exports = __webpack_public_path__ + "assets/img/push-preview-pc-ru.e655d3b9.svg";